import React from 'react';
import PropTypes from 'prop-types';
import { map, upperFirst } from 'lodash';
import { withProps } from 'recompose';

import { getHourString } from 'utils/time/formatHours';

import { H3 } from 'components/core/Typography';

import './HoursList.scss';

export const enhance = withProps((props) => ({
	hoursSchema: map(
		props.hours,
		(hour, key) =>
			`${upperFirst(key.substr(0, 2))} ${hour.open}-${hour.closed}`,
	).join(', '),
	hours: map(props.hours, (hour, key) => ({
		label: upperFirst(key.substr(0, 3)),
		hoursStr: getHourString(hour),
	})),
}));

export function HoursList({ hours, hoursSchema, listTitle }) {
	return (
		<div
			className="facility-hours-list"
			itemProp="openingHours"
			dateTime={hoursSchema}
		>
			<H3
				size="small"
				className="facility-hours-title"
			>
				{listTitle}
			</H3>
			<table className="hours">
				<tbody>
					{map(hours, (hour) => (
						<tr key={hour.label}>
							<th>{hour.label}</th>
							<td>{hour.hoursStr}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}

HoursList.propTypes = {
	listTitle: PropTypes.string.isRequired,
	hoursSchema: PropTypes.string.isRequired,
	hours: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			hoursStr: PropTypes.string.isRequired,
		}),
	).isRequired,
};

export default enhance(HoursList);
